import { CircularProgress, Stack } from '@mui/material';
import loadingImg from '../../images/loading-page/Logo-Kiabi-bleu-transparent.png';

const PageLoading = () => {
    return (
        <Stack
            height="100vh"
            width="100vw"
            alignItems="center"
            justifyContent="center"
            display="flex"
        >
            <CircularProgress />
            <img src={loadingImg} alt="Logo Kiabi" />
        </Stack>
    );
};

export default PageLoading;
